export const PRE_SUBMIT_PRODUCT_THRESHOLD = "PRE_SUBMIT_PRODUCT_THRESHOLD";
